<template>
  <el-dialog
    title="选择订单"
    :visible.sync="visible"
    width="960px"
    append-to-body=""
    @closed="handleClosed">
    <div class="search-form">
      <el-input
        v-model="config.code"
        placeholder="请输入订单号"
        style="width: 200px"
        clearable=""
        class="input-with-select">
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="handleCurrentChange(1)"></el-button>
      </el-input>
    </div>
    <el-table
      v-loading="loading"
      border
      highlight-current-row
      :data="list"
      @current-change="handleCurrentRowChange">
      <el-table-column
        label=""
        :resizable="false"
        width="30">
        <template slot-scope="{row}">
          <el-radio
            v-model="current.id"
            :label="row.id">&nbsp;</el-radio>
        </template>
      </el-table-column>
      <el-table-column
        label="订单号"
        width="180"
        :resizable="false"
        prop="code"></el-table-column>
      <el-table-column
        label="收件人"
        width="240"
        :resizable="false">
        <template slot-scope="{row}">
          <div style="display: flex;align-items: center;">
            <span>{{ row.receiverName }}</span>
            <!-- <el-link
              style="margin-left:5px"
              type="primary"
              :underline="false">[{{ row.receiverTel }}]</el-link> -->
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="订单来源"
        :resizable="false">
        <template slot-scope="{row}">
          {{ row.source | sourceName() }}
        </template>
      </el-table-column>
      <el-table-column
        label="发货状态"
        :resizable="false">
        <template slot-scope="{row}">
          {{ row.outStatus | orderOutStatusName() }}
        </template>
      </el-table-column>
      <el-table-column
        label="创建时间"
        :resizable="false"
        width="140">
        <template slot-scope="{row}">
          {{ row.tradeTime | dateformat( ) }}
        </template>
      </el-table-column>
    </el-table>
    <pagination-new
      v-model="config"
      :total="total"
      :fetch="fetchList" />
    <div slot="footer">
      <el-button @click="toggleModal(false)">取 消</el-button>
      <el-button
        type="primary"
        @click="add">确 定</el-button>
    </div>
    <!-- <notag-returen-modal ref="notag" /> -->
  </el-dialog>
</template>
<script>
// import NotagReturenModal from './notag-returen-modal.vue'

export default {
  name: 'OrderSelectModal',
  components: { },
  props: {
    callback: Function,
    options: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false,
      list: [],
      visible: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        code: ''
      },
      total: 0,
      current: {}
    }
  },
  created() { },
  mounted() { },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.list = []
      this.config.pageNum = 1
      this.total = 0
      this.current = {}
    },
    handleCurrentChange(cur) {
      this.config.pageNum = cur
      this.fetchList()
    },
    add() {
      if (!this.current.id) {
        this.$message.error('请选择一个订单')
        return
      }
      this.callback && this.callback(this.current.id)
      // this.getoutstockorder(this.current.id)
    },
    handleCurrentRowChange(row) {
      this.current = row || {}
    },
    fetchList(cb) {
      this.loading = true
      this.$store.dispatch('outstock/getsaleslist', {
        payload: {
          ...this.config,
          ...this.options
        },
        success: res => {
          this.loading = false
          this.total = res.data.data.total
          this.list = res.data.data.records
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetch() {
      // this.options = options
      this.fetchList(() => {
        this.toggleModal(true)
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.search-form {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}
</style>
